module.exports = __webpack_public_path__ + "img/404.941e8e0e.png";